import userClient from '../config/api/userClient';
import guestClient from '../config/api/guestClient';
var notificationUrl = "notifications";
var changeAlertUrl = "notifications/turnOnOffAlertNotification/";
var markAsReadUrl = "notifications/markAsRead";
export var getNotification = function (params) {
    return userClient.get(notificationUrl, { params: params });
};
export var markAsReadNotification = function (id) {
    return userClient.put(notificationUrl + "/" + id);
};
export var deleteNotification = function (id) {
    return userClient.delete(notificationUrl + "/" + id);
};
export var onChangeAlertNotification = function (id, body) {
    return userClient.put(changeAlertUrl + "/" + id, body);
};
export var markAsReadAll = function () {
    return userClient.post(markAsReadUrl);
};
export var globalUpdateNotification = function (params) {
    return guestClient.get(notificationUrl + "/count", { params: params });
};
